import type { CustomIconProps } from '../types';

const DarkFilledCircle = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height || '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <circle cx="6" cy="6" r="6" fill="#C6C6C6" />
    </svg>
);

export default DarkFilledCircle;
